document.getElementById("delete-account-button").addEventListener("click", function() {
	const customerEmail = document.querySelector("#delete-account-container p strong").innerText.trim();
	fetch("https://creaddictive.ddns.net/request-account-deletion", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				email: customerEmail,
				message: "Demande de suppression de compte pour : " + customerEmail,
			}),
		})
		.then((response) => {
			if (response.ok) {
				document.getElementById("delete-account-form").style.display = "none";
				document.getElementById("confirmation-message").style.display = "block";
			} else {
				alert("Une erreur s'est produite. Veuillez réessayer.");
			}
		})
		.catch((error) => {
			console.error("Erreur:", error);
			alert("Une erreur s'est produite. Veuillez réessayer.");
		});
});